import { ULID } from '~shared/shared.types';

/**
 * ULIDs embed their creation timestamp in their leading characters, so ordering
 * them as plain strings puts entities in the order they were created. Ids that
 * are not ULIDs (the 'new' and 'temp' placeholders) are lowercase and therefore
 * sort after every real entity, which is where a not-yet-persisted entry belongs.
 */
export const compareUlid = (a: ULID, b: ULID): number => (a < b ? -1 : a > b ? 1 : 0);

export const sortByUlid = <T extends { id: ULID }>(entities: T[]): T[] =>
	[...entities].sort((a, b) => compareUlid(a.id, b.id));
